/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Mcp_Prereq_3Inputs */

const en_directory_mcp_prereq_3 = /** @type {(inputs: Directory_Mcp_Prereq_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send it as a Bearer header on every MCP request.`)
};

const zh_directory_mcp_prereq_3 = /** @type {(inputs: Directory_Mcp_Prereq_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每次 MCP 请求都以 Bearer 头发送它。`)
};

/**
* | output |
* | --- |
* | "Send it as a Bearer header on every MCP request." |
*
* @param {Directory_Mcp_Prereq_3Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_mcp_prereq_3 = /** @type {((inputs?: Directory_Mcp_Prereq_3Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Mcp_Prereq_3Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_mcp_prereq_3(inputs)
	return zh_directory_mcp_prereq_3(inputs)
});
export { directory_mcp_prereq_3 as "directory.mcp.prereq_3" }